<template>
  <div id="app">
    <Header v-if="globalVariable"></Header>
    <router-view/>
    <!-- <Footer></Footer> -->
    <GoBack></GoBack>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    globalVariable() {
      return this.$store.getters.getisShowHeader;
    }
  },
}
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

/* 确保主内容区域自动填充可用空间 */
#app > *:not(#footer) {
  flex: 1 0 auto;
}

/* Footer不会被压缩 */
#footer {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue